import { withLoader } from 'util/routeHelper';

export default store => ({
	path: 'privacy',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'privacy',
				),
			store,
			'PRIVACY',
		),
	},
});



// WEBPACK FOOTER //
// ./src/routes/Privacy/index.js